/**
 * @fileoverview Theme toggle component.
 * @summary Toggle switch for dark/light mode.
 *
 * @package KaraoNow
 * @module apps/front/src/components/ThemeToggle
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { useTheme } from '../hooks/useTheme.js'

/**
 * @summary Theme toggle component.
 * @returns {React.ReactElement} Theme toggle button.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export default function ThemeToggle() {
  const [theme, setTheme] = useTheme()
  const isDark = theme === 'dark'

  const toggleTheme = () => setTheme(isDark ? 'light' : 'dark')

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="flex items-center justify-center  rounded-lg text-(--color-text-secondary) hover:text-(--color-text-primary) hover:bg-(--color-bg-tertiary)  transition-colors"
      aria-label={isDark ? 'Activer le mode clair' : 'Activer le mode sombre'}
      title={isDark ? 'Activer le mode clair' : 'Activer le mode sombre'}
    >
      <FontAwesomeIcon icon={isDark ? faSun : faMoon} className="w-5 h-5" />
    </button>
  )
}
